import Http from '../utils/http';
import { API_URL } from '../common/constant';

export default class API {
  constructor(store) {
    this.store = store;
  }

  post(url, query, data) {
    const http = new Http(this.store);
    return http.post(url, query, data);
  }

  init(data) {
    return this.post(API_URL.INIT, null, data).then(rs => rs.data);
  }

  sendMsg(type, channelId, msg = {}, context = {}, no_audit = 0, tag) {
    const data = {};
    data.type = type;
    data.channel_id = channelId;
    data.no_audit = no_audit;
    if (tag) data.tag = tag;
    data.body = typeof msg === 'string' ? msg : JSON.stringify(msg);
    data.context = JSON.stringify(context);
    return this.post(API_URL.SEND_MESSAGE, null, data).then(rs => rs.data);
  }

  sendDirect(type, channelId, user_ids, msg = {}, context = {}, no_audit = 0, tag) {
    const data = {};
    data.type = type;
    data.channel_id = channelId;
    data.no_audit = no_audit;
    if (tag) data.tag = tag;
    data.body = typeof msg === 'string' ? msg : JSON.stringify(msg);
    data.context = JSON.stringify(context);
    const path =
      user_ids.split(',').length <= 1 ? API_URL.SEND_MESSAGE_DIRECT_SINGLE : API_URL.SEND_MESSAGE_DIRECT_MULTI;
    return this.post(path, null, data).then(rs => rs.data);
  }
}
